import React, { FC, KeyboardEvent } from 'react';
import { Box, Button, Autocomplete, TextField } from '@mui/material';
import { FilterInputProps } from './types';

const FilterInput: FC<FilterInputProps> = ({
  options,
  value,
  placeholder,
  buttonText,
  onValueChange,
  onAdd
}) => {
  const handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Enter' && value?.trim()) {
      event.preventDefault();
      onAdd(value);
    }
  };

  return (
    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', mb: 2 }}>
      <Autocomplete
        size="small"
        freeSolo
        options={options}
        value={value}
        onChange={(_, newValue) => {
          if (newValue) {
            onAdd(newValue);
          }
        }}
        onInputChange={(event, newInputValue) => {
          onValueChange(newInputValue);
        }}
        onKeyDown={handleKeyDown}
        renderInput={(params) => <TextField {...params} placeholder={placeholder} />}
        sx={{ flex: 1 }}
      />
      <Button
        variant="outlined"
        size="small"
        onClick={() => onAdd(value)}
        disabled={!value?.trim()}
      >
        {buttonText}
      </Button>
    </Box>
  );
};

export default FilterInput;
